export default __webpack_public_path__ + "static/media/catdog.f673f7c1.png";